// import { Injectable, NgZone, inject, signal } from '@angular/core';
// import { Observable, of, timer } from 'rxjs';
// import {
//     catchError,
//     filter,
//     finalize,
//     switchMap,
//     take,
//     takeWhile,
//     tap,
// } from 'rxjs/operators';

// import { AccountService } from 'app/modules/admin/parametre/account/account.service';
// import { FcmToken } from './fcm-token.interface';
// import { HttpClient } from '@angular/common/http';
// import { Platform } from '@angular/cdk/platform';
// import { Router } from '@angular/router';
// import { StorageService } from './../../modules/auth/services/storage.service';
// import { environment } from 'environments/environment';

// export interface NotificationData {
//     data: any;
//     actionType: 'received' | 'clicked' | 'background' | 'message';
//     url?: string;
// }

// @Injectable({
//     providedIn: 'root',
// })
// export class FcmTokenService {
//     private http = inject(HttpClient);
//     private accountService = inject(AccountService); // Utiliser uniquement AccountService
//     private router = inject(Router);
//     private platform = inject(Platform);
//     private zone = inject(NgZone);
//     private storageService = inject(StorageService);

//     // Signaux pour l'état du service
//     fcmToken = signal<string | null>(null);
//     lastNotification = signal<NotificationData | null>(null);

//     // URL backend pour l'enregistrement du token
//     private readonly API_URL = `${environment.apiNest_2}/api/v1/fcm-tokens`;

//     // Déterminer la plateforme
//     private readonly currentPlatform = this.detectPlatform();

//     /**
//      * Vérifie périodiquement l'authentification de l'utilisateur et enregistre le token FCM
//      * une fois l'utilisateur authentifié.
//      * @param token Le token FCM à enregistrer
//      * @returns Observable qui émet le résultat de l'enregistrement du token
//      */
//     checkAuthAndRegisterToken(token: string): void {
//         const iTimer = timer(3000, 5000)
//             .pipe(take(60))
//             .subscribe(() => {
//                 let isAuthenticated = false;
//                 this.accountService
//                     .getConnectedUser()
//                     .pipe(
//                         switchMap(() => this.accountService.getConnectedUser()),
//                         // Continuer tant que l'utilisateur n'est pas authentifié
//                         takeWhile((user) => {
//                             console.log(
//                                 "En attente de connexion de l'utilisateur"
//                             );
//                             isAuthenticated = !!user;
//                             return !isAuthenticated;
//                         }, true),
//                         // Quand l'utilisateur est authentifié, enregistrer le token
//                         switchMap((user) => {
//                             if (user) {
//                                 return this.registerTokenWithBackend(
//                                     token,
//                                     user
//                                 );
//                             }
//                             return of(null);
//                         }),
//                         finalize(() => {
//                             iTimer.unsubscribe();
//                         })
//                         // On continue seulement si on a bien reçu un utilisateur
//                         //filter((user) => !!user),
//                     )
//                     .subscribe({
//                         next: (val) => {
//                             console.log('val de retrour du back', val);
//                         },
//                         error: (err) => {
//                             console.log('erroer du bakc', err);
//                         },
//                     });
//             });
//     }

//     constructor() {
//         this.setupBridgeListeners();

//         // S'assurer que nous enregistrons le token quand l'utilisateur se connecte
//         this.accountService
//             .getConnectedUser()
//             .pipe(
//                 // On continue seulement si on a bien reçu un utilisateur
//                 filter((user) => !!user),
//                 switchMap((user) => {
//                     // Le token actuel est-il déjà disponible ?
//                     if (this.fcmToken()) {
//                         // Passer l'utilisateur à la méthode d'enregistrement
//                         return this.registerTokenWithBackend(
//                             this.fcmToken()!,
//                             user
//                         );
//                     }
//                     return of(null);
//                 })
//             )
//             .subscribe();
//     }

//     /**
//      * Détecte la plateforme actuelle
//      */
//     private detectPlatform(): 'IOS' | 'WEB' | 'ANDROID' {
//         if (this.platform.IOS) return 'IOS';
//         if (this.platform.ANDROID) return 'ANDROID';
//         return 'WEB';
//     }

//     /**
//      * Configure les écouteurs pour recevoir les données de l'application native
//      */
//     private setupBridgeListeners(): void {
//         // Écouter l'événement qui indique la réception d'un token FCM
//         window.addEventListener('FCMTokenReceived', ((event: CustomEvent) => {
//             this.zone.run(() => {
//                 const token = event.detail?.token;
//                 if (token) {
//                     console.log('FCM Token reçu du bridge:', token);
//                     this.fcmToken.set(token);
//                     console.log(
//                         'le tocken est bien stocké dans un signal ',
//                         this.fcmToken()
//                     );
//                     this.checkAuthAndRegisterToken(this.fcmToken());
//                 }
//             });
//         }) as EventListener);

//         // Écouter l'événement qui indique la réception d'une notification
//         window.addEventListener('NotificationReceived', ((
//             event: CustomEvent
//         ) => {
//             console.log('Notification reçue du bridge:', event);

//             this.zone.run(() => {
//                 const notification: NotificationData = {
//                     data: event.detail?.data || {},
//                     actionType: event.detail?.actionType || 'received',
//                 };

//                 // Ajouter l'URL si présente
//                 if (event.detail?.url) {
//                     notification.url = event.detail.url;
//                 }

//                 console.log('Notification reçue du bridge:', notification);
//                 this.lastNotification.set(notification);

//                 // Traiter la notification
//                 this.handleNotification(notification);
//             });
//         }) as EventListener);
//     }

//     /**
//      * Traite les notifications reçues
//      */
//     private handleNotification(notification: NotificationData): void {
//         if (notification.actionType === 'clicked') {
//             // Navigation vers l'URL spécifiée dans la notification
//             const targetUrl =
//                 notification.url ||
//                 notification.data?.url ||
//                 notification.data?.target_url ||
//                 notification.data?.['gcm.notification.target_url'];

//             if (targetUrl) {
//                 this.router.navigateByUrl(targetUrl);
//             }

//             // Émettre un événement pour que les composants puissent réagir
//             this.emitNotificationEvent('notification-clicked', notification);
//         } else {
//             // Émettre des événements différents selon le type de notification
//             this.emitNotificationEvent(
//                 `notification-${notification.actionType}`,
//                 notification
//             );
//         }
//     }

//     /**
//      * Émet un événement personnalisé pour les composants Angular
//      */
//     private emitNotificationEvent(eventName: string, data: any): void {
//         const event = new CustomEvent(eventName, { detail: data });
//         window.dispatchEvent(event);
//     }

//     /**
//      * Enregistre le token FCM auprès du backend
//      * @param token Le token FCM à enregistrer
//      * @param user Les données de l'utilisateur connecté (optionnel)
//      */
//     private registerTokenWithBackend(
//         token: string,
//         userId: string
//     ): Observable<any> {
//         if (!token) return of(null);

//         const payload: FcmToken = {
//             token,
//             platform: this.detectPlatform(),
//             // timestamp: new Date().toISOString(),
//             clubUser_id: userId,
//             // Ajouter l'ID de l'utilisateur si disponible
//             clubUserClub_id: this.storageService.getItem<string>('clubId')
//         };

//         return this.http.post(this.API_URL, payload).pipe(
//             tap(() =>
//                 console.log('Token enregistré avec succès auprès du backend')
//             ),
//             catchError((error) => {
//                 console.error(
//                     "Erreur lors de l'enregistrement du token:",
//                     error
//                 );
//                 return of(null);
//             })
//         );
//     }

//     /**
//      * Méthode publique pour demander les autorisations de notification à l'appareil native
//      */
//     requestNotificationPermission(): Promise<boolean> {
//         return new Promise((resolve) => {
//             // Fonction de callback pour recevoir la réponse de l'application native
//             const permissionCallback = (event: CustomEvent) => {
//                 const granted = event.detail?.granted || false;
//                 window.removeEventListener(
//                     'NotificationPermissionResult',
//                     permissionCallback as EventListener
//                 );
//                 resolve(granted);
//             };

//             // Écouter la réponse
//             window.addEventListener(
//                 'NotificationPermissionResult',
//                 permissionCallback as EventListener
//             );

//             // Appeler la fonction du bridge native
//             if (
//                 typeof window['nativeBridge']?.requestNotificationPermission ===
//                 'function'
//             ) {
//                 window['nativeBridge'].requestNotificationPermission();
//             } else {
//                 // Si le bridge n'est pas disponible, émettre un événement pour que l'app native puisse le capter
//                 const event = new CustomEvent('RequestNotificationPermission');
//                 window.dispatchEvent(event);
//             }

//             // Timeout de sécurité en cas de non-réponse
//             setTimeout(() => {
//                 window.removeEventListener(
//                     'NotificationPermissionResult',
//                     permissionCallback as EventListener
//                 );
//                 resolve(false);
//             }, 5000);
//         });
//     }

//     /**
//      * Réinitialise le token (lors d'une déconnexion par exemple)
//      */
//     clearToken(): Observable<any> {
//         const currentToken = this.fcmToken();
//         if (!currentToken) return of(null);

//         // Informer le backend que ce token n'est plus valide
//         return this.http.delete(`${this.API_URL}/${currentToken}`).pipe(
//             tap(() => {
//                 this.fcmToken.set(null);
//                 console.log('Token effacé avec succès');
//             }),
//             catchError((error) => {
//                 console.error('Erreur lors de la suppression du token:', error);
//                 // On efface quand même localement
//                 this.fcmToken.set(null);
//                 return of(null);
//             })
//         );
//     }

//     /**
//      * Récupère l'utilisateur actuellement connecté
//      * Méthode de commodité qui délègue à AccountService
//      */
//     getConnectedUser(): Observable<any> {
//         return this.accountService.getConnectedUser();
//     }
// }

// // Étendre l'interface Window pour le typesafe avec TypeScript
// declare global {
//     interface Window {
//         nativeBridge?: {
//             requestNotificationPermission?: () => void;
//             [key: string]: any;
//         };
//     }
// }

import { Injectable, Injector, effect, inject, signal } from '@angular/core';
import { Observable, of, timer } from 'rxjs';
import {
    catchError,
    filter,
    finalize,
    switchMap,
    take,
    takeWhile,
    tap,
} from 'rxjs/operators';

import { AccountService } from 'app/modules/admin/parametre/account/account.service';
import { FcmToken } from './fcm-token.interface';
import { HttpClient } from '@angular/common/http';
import { NativeBridgeService } from '../native-bridge.service'; // Assurez-vous que le chemin est correct
import { Platform } from '@angular/cdk/platform';
import { Router } from '@angular/router';
import { StorageService } from './../../modules/auth/services/storage.service';
import { environment } from 'environments/environment';
import { clubConfig } from 'config/club.config';

export interface NotificationData {
    data: any;
    actionType: 'received' | 'clicked' | 'background' | 'message';
    url?: string;
}

@Injectable({
    providedIn: 'root',
})
export class FcmTokenService {
    private http = inject(HttpClient);
    private accountService = inject(AccountService);
    private router = inject(Router);
    private platform = inject(Platform);
    private storageService = inject(StorageService);
    private nativeBridge = inject(NativeBridgeService);
    private injector = inject(Injector); // Injecter Injector pour les effets

    // Signaux pour l'état du service
    fcmToken = signal<string | null>(null);
    lastNotification = signal<NotificationData | null>(null);

    // URL backend pour l'enregistrement du token
    private readonly API_URL = `${environment.apiNest_2}/api/v1/fcm-tokens`;
    // Déterminer la plateforme
    private readonly currentPlatform = this.detectPlatform();

   constructor() {
        console.log('🚨 ===== FcmTokenService CONSTRUCTOR =====');
        console.log('🚨 NativeBridge injecté:', !!this.nativeBridge);
        console.log('🚨 Platform:', this.currentPlatform);
        console.log('🚨 Début initialisation...');
        
        this.setupNativeBridgeSubscriptions();
        this.setupUserAuthenticationLogic();
        
        // ✅ NOUVEAU: Test de communication immédiat
        setTimeout(() => {
              console.log('****Waiting before triggering testBridgeCommunication****');
            this.testBridgeCommunication();
          
        }, 5000); //il etait 2000 je lai augmanter a 5000 pour laisser le temps au bridge de s'initialiser
        
        console.log('🚨 Initialisation bridge...');
        this.nativeBridge.initializeBridge();
        console.log('🚨 =====================================');
    }


/**
     * ✅ NOUVEAU: Test de communication avec le bridge
     */
    private testBridgeCommunication(): void {
        console.log('🧪 ===== TEST BRIDGE COMMUNICATION =====');
        console.log('🧪 Bridge isRunningInWebView:', this.nativeBridge.isRunningInWebView());
        console.log('🧪 Bridge isBridgeReady:', this.nativeBridge.isBridgeReady());
        console.log('🧪 Bridge connectionStatus:', this.nativeBridge.isConnected());
        console.log('🧪 Bridge FCM Token actuel:', this.nativeBridge.fcmToken());
        
        // Test explicite de demande de token
        console.log('🧪 Demande explicite de token FCM...');
        this.nativeBridge.requestFCMToken();
        
        // Test avec la nouvelle méthode
        if (typeof this.nativeBridge.requestFCMTokenExplicitly === 'function') {
            console.log('🧪 Demande EXPLICITE via nouvelle méthode...');
            this.nativeBridge.requestFCMTokenExplicitly();
        }
        
        // Debug info
        console.log('🧪 Demande debug info...');
        this.nativeBridge.debugTokenState();
        
        console.log('🧪 =====================================');
    }


    /**
     * Configure les abonnements aux Signals du NativeBridgeService
     */
    private setupNativeBridgeSubscriptions(): void {
        // effect(
        //     () => {
        //         const token = this.nativeBridge.fcmToken();
        //         if (token) {
        //             console.log(
        //                 'FCM Token reçu du NativeBridgeService (via effect):',
        //                 token
        //             );
        //             // this.fcmToken.set(token); // Met à jour le signal local de FcmTokenService
        //             // console.log(
        //             //     'Le token est bien stocké dans un signal local:',
        //             //     this.fcmToken()
        //             // );
        //             this.checkAuthAndRegisterToken(token);
        //             // La logique d'enregistrement sera déclenchée par setupUserAuthenticationLogic
        //             // une fois que l'utilisateur est connecté et que le token est disponible.
        //         }
        //     },
        //     { injector: this.injector }
        // ); // Passer l'injector
effect(() => {
    const token = this.nativeBridge.fcmToken();
    if (!token) return;

    console.log('yeees,Token détecté dans effect');

    this.accountService.getConnectedUser()
        .pipe(take(1), filter(user => !!user?.id))
        .subscribe(user => {
            console.log('**/**User connecté dans effect:', user.id);
            this.registerTokenWithBackend(token, user).subscribe();
        });
}, { injector: this.injector });
        effect(
            () => {
                const notification =
                    this.nativeBridge.latestNativeNotification();
                if (notification) {
                    console.log(
                        'Notification reçue du NativeBridgeService (via effect):',
                        notification
                    );
                    this.lastNotification.set(notification);
                    this.handleNotification(notification);
                }
            },
            { injector: this.injector }
        );
    }

    /**
     * Configure la logique d'authentification utilisateur et l'enregistrement du token
     */
    private setupUserAuthenticationLogic(): void {
        // S'assurer que nous enregistrons le token quand l'utilisateur se connecte
        this.accountService
            .getConnectedUser()
            .pipe(
                filter((user) => !!user), // On continue seulement si on a bien reçu un utilisateur
                switchMap((user) => {
                    // Attend que le token FCM soit disponible via le signal
                    // Ceci est une version simplifiée, dans un cas réel, vous pourriez vouloir
                    // une logique plus robuste pour attendre le token s'il n'est pas encore là.
                    if (this.fcmToken()) {
                        console.log(
                            'Utilisateur connecté et FCM Token disponible, enregistrement...'
                        );
                        return this.registerTokenWithBackend(
                            this.fcmToken()!,
                            user
                        );
                    } else {
                        console.log(
                            'Utilisateur connecté mais FCM Token non encore disponible. Attente...'
                        );
                        // Vous pouvez ajouter une logique d'attente ici si nécessaire,
                        // mais le `nativeBridge.fcmToken.subscribe` gère déjà la mise à jour
                        // du signal `fcmToken` de ce service une fois qu'il est reçu.
                        // La `checkAuthAndRegisterToken` peut être adaptée pour un polling si besoin.
                        return of(null);
                    }
                })
            )
            .subscribe({
                next: (res) => {
                    if (res) {
                        console.log(
                            'Enregistrement du token suite à la connexion utilisateur réussi:',
                            res
                        );
                    }
                },
                error: (err) => {
                    console.error(
                        "Erreur lors de l'enregistrement du token suite à la connexion:",
                        err
                    );
                },
            });
    }

    /**
     * Vérifie périodiquement l'authentification de l'utilisateur et enregistre le token FCM
     * une fois l'utilisateur authentifié.
     * @param token Le token FCM à enregistrer
     * @returns Observable qui émet le résultat de l'enregistrement du token
     */
    checkAuthAndRegisterToken(token: string): void {
        const iTimer = timer(3000, 5000)
            .pipe(take(60)) // Tente pendant 60 * 5 secondes = 5 minutes
            .subscribe(() => {
                this.accountService
                    .getConnectedUser()
                    .pipe(
                        take(1), // Prendre la première valeur et compléter pour éviter des souscriptions multiples du timer
                        filter((user) => !!user), // S'assurer que l'utilisateur est connecté
                        switchMap((user) => {
                            if (user && token) {
                                // S'assurer que l'utilisateur et le token sont présents
                                console.log(
                                    'Utilisateur authentifié par checkAuthAndRegisterToken, enregistrement du token...'
                                );
                                return this.registerTokenWithBackend(
                                    token,
                                    user
                                );
                            }
                            return of(null); // Ne rien faire si pas d'utilisateur ou de token
                        }),
                        finalize(() => {
                            iTimer.unsubscribe(); // Arrêter le timer après l'opération
                            console.log(
                                'Timer de checkAuthAndRegisterToken terminé.'
                            );
                        }),
                        catchError((err) => {
                            console.error(
                                'Erreur dans le pipe checkAuthAndRegisterToken:',
                                err
                            );
                            return of(null);
                        })
                    )
                    .subscribe({
                        next: (val) => {
                            if (val) {
                                console.log(
                                    'Retour du backend (checkAuthAndRegisterToken):',
                                    val
                                );
                            }
                        },
                        error: (err) => {
                            console.error(
                                "Erreur lors de l'enregistrement du token via checkAuthAndRegisterToken:",
                                err
                            );
                        },
                    });
            });
    }

    /**
     * Détecte la plateforme actuelle
     */
    private detectPlatform(): 'IOS' | 'WEB' | 'ANDROID' {
        if (this.platform.IOS) return 'IOS';
        if (this.platform.ANDROID) return 'ANDROID';
        return 'WEB';
    }

    /**
     * Traite les notifications reçues
     */
    private handleNotification(notification: NotificationData): void {
        if (notification.actionType === 'clicked') {
            // Navigation vers l'URL spécifiée dans la notification
            const targetUrl =
                notification.url ||
                notification.data?.url ||
                notification.data?.target_url ||
                notification.data?.['gcm.notification.target_url'];

            if (targetUrl) {
                this.router.navigateByUrl(targetUrl);
            }

            // Émettre un événement pour que les composants puissent réagir
            this.emitNotificationEvent('notification-clicked', notification);
        } else {
            // Émettre des événements différents selon le type de notification
            this.emitNotificationEvent(
                `notification-${notification.actionType}`,
                notification
            );
        }
    }

    /**
     * Émet un événement personnalisé pour les composants Angular
     * (Peut être remplacé par un Subject/Signal si toutes les écoutes se font via le service)
     */
    private emitNotificationEvent(eventName: string, data: any): void {
        // Si d'autres composants s'abonnent via window.addEventListener, gardez cette ligne.
        // Sinon, vous pourriez exposer un Subject dans ce service pour une communication interne.
        const event = new CustomEvent(eventName, { detail: data });
        window.dispatchEvent(event);
    }

    /**
     * Enregistre le token FCM auprès du backend
     * @param token Le token FCM à enregistrer
     * @param user Les données de l'utilisateur connecté (optionnel)
     */
    private registerTokenWithBackend(
        token: string,
        user: any // Ajustez le type 'any' avec votre interface utilisateur réelle
    ): Observable<any> {
        if (!token || !user?.id) {
            // Vérifier si user.id est défini
            console.warn(
                "Impossible d'enregistrer le token: Token ou User ID manquant."
            );
            return of(null);
        }

        const payload: FcmToken = {
            token,
            platform: this.detectPlatform(),
            clubUser_id: user.id, // Assurez-vous que l'ID de l'utilisateur est correct ici
            clubUserClub_id: clubConfig[0].id,
        };

        return this.http.post(this.API_URL, payload).pipe(
            tap(() =>
                console.log('Token enregistré avec succès auprès du backend')
            ),
            catchError((error) => {
                console.error(
                    "Erreur lors de l'enregistrement du token:",
                    JSON.stringify(error)
                );
                return of(null);
            })
        );
    }

    /**
     * Méthode publique pour demander les autorisations de notification à l'appareil native
     */
    requestNotificationPermission(): Observable<boolean> {
        // Utiliser la méthode du NativeBridgeService qui retourne un Observable<boolean>
        return this.nativeBridge.requestNativeNotificationPermission().pipe(
            tap((granted) =>
                console.log(
                    'Permission de notification native accordée:',
                    granted
                )
            ),
            catchError((err) => {
                console.error(
                    'Erreur lors de la demande de permission de notification native via NativeBridgeService:',
                    err
                );
                return of(false); // Retourne false en cas d'erreur
            })
        );
    }

    /**
     * Réinitialise le token (lors d'une déconnexion par exemple)
     */
    clearToken(): Observable<any> {
        const currentToken = this.fcmToken();
        if (!currentToken) return of(null);

        // Informer le backend que ce token n'est plus valide
        return this.http.delete(`${this.API_URL}/${currentToken}`).pipe(
            tap(() => {
                this.fcmToken.set(null); // Réinitialise le signal local
                console.log('Token effacé avec succès');
            }),
            catchError((error) => {
                console.error('Erreur lors de la suppression du token:', error);
                this.fcmToken.set(null); // On efface quand même localement
                return of(null);
            })
        );
    }

    /**
     * Récupère l'utilisateur actuellement connecté
     * Méthode de commodité qui délègue à AccountService
     */
    getConnectedUser(): Observable<any> {
        return this.accountService.getConnectedUser();
    }
}

// --- Suppression de cette déclaration globale ici, car NativeBridgeService la gère déjà ---
// declare global {
//     interface Window {
//         nativeBridge?: {
//             requestNotificationPermission?: () => void;
//             [key: string]: any;
//         };
//     }
// }
